/**
 * Concurrence optimiste : « la version que j'éditais est-elle encore celle du
 * serveur ? »
 *
 * Le repère est `updated_at`. La comparaison paraît triviale, elle ne l'est
 * pas : Postgres rend des microsecondes (`…T21:15:33.123456+00:00`) que
 * `Date` tronque à la milliseconde, le fuseau peut s'écrire `+00:00` ou `Z`
 * d'un aller-retour à l'autre, et un cache local peut avoir ré-sérialisé la
 * valeur. Comparer les chaînes brutes fabriquerait des conflits là où rien n'a
 * bougé — et un faux conflit est pire qu'une absence de contrôle : il bloque un
 * travail légitime derrière une question absurde.
 *
 * On compare donc des INSTANTS, avec un repli sur l'égalité stricte quand la
 * valeur n'est pas une date analysable (mieux vaut ne pas conclure que
 * conclure faux).
 */
export function sameInstant(a: string, b: string): boolean {
  const ta = Date.parse(a);
  const tb = Date.parse(b);
  if (Number.isNaN(ta) || Number.isNaN(tb)) return a === b;
  return ta === tb;
}

/**
 * Le document a-t-il été modifié ailleurs depuis la version `base` ?
 *
 * `base` absente = l'appelant ne sait pas de quelle version il part (saisie en
 * ligne ordinaire) : pas de contrôle, dernier-écrit-gagne comme avant.
 * `serverUpdatedAt` vide = le serveur ne nous dit rien d'exploitable : on ne
 * bloque pas sur une supposition.
 */
export function isConcurrentlyEdited(
  base: string | undefined | null,
  serverUpdatedAt: string | undefined | null,
): boolean {
  if (!base || !serverUpdatedAt) return false;
  return !sameInstant(serverUpdatedAt, base);
}
